import Directions from '@alltrails/shared/icons/Directions';
import { COLOR_INTERACTIVE_DEFAULT } from '@alltrails/shared/denali/tokens';
import useUser from 'hooks/useUser';
import { logTrailDetailsDirectionsClicked } from 'utils/trail_analytics_helpers';
import { TrailId } from 'types/Trails';
import SignupModal from 'components/SignupModal';
import useToggle from '@alltrails/shared/hooks/useToggle';
import { useIntl } from '@alltrails/shared/react-intl';
import ActionBarItem from '../ActionBarItem';

type Props = {
  disabled: boolean;
  geoloc: { lat: number; lng: number };
  trailId: TrailId;
};

const DirectionsButton = ({ disabled = false, geoloc = { lat: null, lng: null }, trailId }: Props) => {
  const intl = useIntl();
  const [isOpen, toggle] = useToggle();
  const user = useUser();
  const url = `https://www.google.com/maps/dir/Current+Location/${geoloc.lat},${geoloc.lng}`;

  return (
    <>
      <SignupModal
        isOpen={isOpen}
        onRequestClose={() => {
          toggle();
        }}
        onSuccess={() => {
          toggle();
          window.open(url);
        }}
      />
      <ActionBarItem
        disabled={disabled || !geoloc.lat || !geoloc.lng}
        icon={<Directions color={COLOR_INTERACTIVE_DEFAULT} />}
        testId="directions-action"
        onClick={() => {
          logTrailDetailsDirectionsClicked(trailId);

          if (!user) {
            toggle();
            return;
          }

          window.open(url);
        }}
        title={intl.formatMessage({ defaultMessage: 'Directions' })}
      />
    </>
  );
};

export default DirectionsButton;
